import "normalize.css/normalize.css";
import "./styles/main.scss";
import 'aos/dist/aos.css'

import { createApp } from "vue";
import { uuid } from "uuidv4";
import AOS from 'aos'
import SvgIcon from "./components/SvgIcon.vue";
import StdLink from "./components/StdLink.vue";
import TelLink from "./components/TelLink.vue";
import CommoditiesScroll from "./components/CommoditiesScroll.vue";
import BlockSlider from "./components/BlockSlider.vue";
import ClientsScroll from "./components/ClientsScroll.vue";
import ClientsScroller from "./components/ClientsScroller.vue";
import SectionsScroll from "./components/SectionsScroll.vue";
import PopupDialog from "./components/PopupDialog.vue";
import PopupForm from "./components/PopupForm.vue";
import ClientsPartners from "./components/ClientsPartners.vue";
import UniversalTabs from "./components/UniversalTabs.vue";
import ReviewsSlider from "./components/ReviewsSlider.vue";
import TextField from "./components/TextField.vue";
import TextArea from "./components/TextArea.vue";
import RequestForm from "./components/RequestForm.vue";
import ContactsMap from "./components/ContactsMap.vue";
import AnimatedNumbers from "./components/AnimatedNumbers.vue";

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".vue-root");

  const links = el.getElementsByTagName("a");
  for (let link of links) {
    if (!link.hasAttribute("is")) {
      link.setAttribute("is", "vue:std-link");
    }
  }

  const popupDialog = document.createElement("popup-dialog");
  popupDialog.setAttribute("v-if", "currentDialog");
  popupDialog.setAttribute("v-bind:key", "currentDialog.id");
  popupDialog.setAttribute("v-bind:dialog", "currentDialog");
  popupDialog.setAttribute("v-on:close", "closeDialog");
  el.append(popupDialog);

  const popupForm = document.createElement("popup-form");
  popupForm.setAttribute("v-if", "isFormOpen");
  popupForm.setAttribute("v-on:close", "closeForm");
  el.append(popupForm);

  const observerEntries = [];
  let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const element = entry.target;
      if (entry.intersectionRatio > 0.999999999) {
        observerEntries.forEach(entry => {
          if (entry.callback) {
            if (entry.element == element) {
              entry.callback();
            }
          }
        });
      } else {
        observerEntries.forEach(entry => {
          if (entry.callbackLeave && entry.element == element) {
            entry.callbackLeave();
          }
        });
      }
    });
  }, {
    root: null,
    rootMargin: '10px',
    threshold: 1.0
  });

  let lastScrollPos = 0;
  const template = el.innerHTML;
  const app = createApp({
    template: template,
    data() {
      return {
        dialogFifo: [],
        isFormOpen: false,
        isMobileMenuOpen: false,
        scrollPos: 0,
        hideMobileHeader: false
      };
    },
    watch: {
      isMobileMenuOpen(value) {
        if (value) {
          document.body.classList.add("no-scroll");
          document.documentElement.classList.add("no-scroll");
        } else {
          document.body.classList.remove("no-scroll");
          document.documentElement.classList.remove("no-scroll");
        }
      },
      scrollPos(value) {
        if (value < 60) {
          document.body.classList.add("scroll-up");
          document.body.classList.remove("scroll-down");
          return;
        }

        if (Math.abs(lastScrollPos - value) > 100) {
          if (value > lastScrollPos) {
            document.body.classList.add("scroll-down");
            document.body.classList.remove("scroll-up");
          } else {
            document.body.classList.add("scroll-up");
            document.body.classList.remove("scroll-down");
          }

          lastScrollPos = value;
        }
      }
    },
    computed: {
      currentDialog() {
        if (!this.dialogFifo && this.dialogFifo.length < 1) {
          return null;
        }

        return this.dialogFifo[0];
      },
      showScrollUp() {
        return this.scrollPos > 300;
      },
    },
    methods: {
      openDialog(text, options, callback) {
        this.dialogFifo.push({
          id: uuid(),
          text: text,
          options: options || {},
          callback: callback || null,
        });
      },
      closeDialog() {
        this.dialogFifo.shift();
      },
      openForm() {
        this.isFormOpen = true;
      },
      closeForm() {
        this.isFormOpen = false;
      },
      toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
      },
      scrollTop() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      observeView(element, callback, callbackLeave) {
        observer.observe(element);

        observerEntries.push({
          element: element,
          callback: callback,
          callbackLeave: callbackLeave
        });
      }
    },
    mounted() {
      window.addEventListener("scroll", () => {
        this.scrollPos = window.scrollY;
      });

      document.body.classList.add("scroll-up");
      document.body.classList.remove("scroll-down");
    },
  });

  app.mixin({
    methods: {
      $v(name) {
        return (window.cms_values || {})[name] || "";
      },
    },
  });

  /*
  app.directive('animation', {
    mounted(el) {
      setTimeout(function () {
        console.log(root);
        root.observeView(el, function () {
          el.classList.add("visible");
          el.classList.remove("invisible");
        }, function () {
          el.classList.remove("visible");
          el.classList.add("invisible");
        });
      }, 50);
    }
  })
  */

  app.use(AOS.init());

  app.component("svg-icon", SvgIcon);
  app.component("std-link", StdLink);
  app.component("tel-link", TelLink);
  app.component("commodities-scroll", CommoditiesScroll);
  app.component("block-slider", BlockSlider);
  app.component("clients-scroll", ClientsScroll);
  app.component("clients-scroller", ClientsScroller);
  app.component("sections-scroll", SectionsScroll);
  app.component("popup-dialog", PopupDialog);
  app.component("popup-form", PopupForm);
  app.component("clients-partners", ClientsPartners);
  app.component("universal-tabs", UniversalTabs);
  app.component("reviews-slider", ReviewsSlider);
  app.component("text-field", TextField);
  app.component("text-area", TextArea);
  app.component("request-form", RequestForm);
  app.component("contacts-map", ContactsMap);
  app.component("animated-numbers", AnimatedNumbers);
  
  app.mount(".vue-root");
});
